export default __webpack_public_path__ + "static/media/close.0882cb97.svg";